import DashboardPages from './DashboardPages'

export default DashboardPages
